import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Skeleton, Box } from "@mui/material";
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import PreviousAssessments from "./partials/home/PreviousAssessments";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import HealthShelfComponent from "./partials/home/HealthShelfComponent";
import DisplayMode from "./partials/displaymodes/DisplayMode";
import OutboundSamlLink from "./partials/home/OutboundSAMLLink";
import { fetchErrorMessages } from "../reducers/reference_errormessages";
import { surveyClear } from "../reducers/survey";
import HomeAssessmentLibrary from "./partials/dynamic/HomeAssessmentLibrary";
import HomeHealthTools from "./partials/dynamic/HomeHealthTools";
import HomeBanner from "./partials/dynamic/HomeBanner";
import HTMLBlock from "./partials/dynamic/HTMLBlock";
import { fetchViewInstances, selectViewInstanceById } from "../reducers/reuseable_vi";
import { globalsettingGetPrioritySesOrgPer, globalsettingSet, selectGlobalSettingEntities, selectSettingForTypeKeyName } from "../reducers/reference_settings";
import Home from "./Home";
import HomeDynamic from "./HomeDynamic";
import { profileClear } from "../reducers/profile";


const HomeReRoute = () => {

  const { user: currentUser } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [settingsLoaded, setSettingsLoaded] = useState(false);
  const [callVI, setCallVI] = useState(true)
  const viewInstance = useSelector(state => selectViewInstanceById(state,'HomePage'))
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const settings = useSelector(state => selectGlobalSettingEntities(state))
  const errormessageStatus = useSelector(state => state.errormessages.status)
  const HomeGuid = useSelector(state=>selectSettingForTypeKeyName(state,{SettingTypeKeyName:"WC HOME PAGE GUID"}))

  useEffect(() => {
    if (window !== undefined) {
      window.scrollTo(0, 0)
    }
    dispatch(profileClear())
  }, [])

  const surveyStatus = useSelector(state => state.surveys.status)
  useEffect(() => {
    if (surveyStatus === 'success') {
      dispatch(surveyClear())
    }
  }, [])
  /*if (!currentUser) {
    return <Navigate to="/login" />;
  }*/

  useEffect(() => {
    
  
    if (currentUser && currentUser.AuthToken && HomeGuid && callVI) {
      
      setLoading(true)
      setCallVI(false);
      dispatch(fetchViewInstances({authToken: currentUser.AuthToken, VIGuid:HomeGuid, VIName:"HomePage"}))
      setLoading(false)
    }
  }, [location.pathname,callVI,HomeGuid, viewInstance, dispatch])
  
  useEffect(() => {
    if (viewInstance?.settings && !settingsLoaded) {
      
      dispatch(globalsettingSet({SettingFamilyKeyName:"session", Settings:viewInstance.settings?.SessionVariableValues}))
      dispatch(globalsettingSet({SettingFamilyKeyName:"organization", Settings:viewInstance.settings?.OrganizationSettingValues}))      
      setSettingsLoaded(true)
    }

  }, [viewInstance, dispatch])
  useEffect(() => {
    if (errormessageStatus === 'idle') {
      dispatch(fetchErrorMessages({ groupGuid: localStorage.getItem('group'), languageID: 1 }))
    }

  }, [errormessageStatus, dispatch])

  const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
      opacity: 1, x: 0, y: 0,
      transition: {
        delay: 0.1,
        duration: 0.5,
      }
    }
  }
  const GetHome=()=>{
    if(HomeGuid && HomeGuid !== '38E01F8C-5C38-423D-8573-23E1BEC87C88'){
        return <HomeDynamic/>
    } else if (HomeGuid) {
        return <Home/>
    } else {
      return <Box></Box>
    }
  }
  return (
    <div>
      <Header />
      <GetHome/>
      <Footer />
    </div>
  );


};

export default HomeReRoute;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */